import { lazy } from "react";

const UserProfile = lazy(() => import("pages/UserProfile"));

const GeneralSettingsPage = lazy(() =>
  import("pages/settings/GeneralSettingsPage")
);
const PreferencesSettingsPage = lazy(() =>
  import("pages/settings/PreferencesSettingsPage")
);
const SettingsPage = lazy(() => import("pages/settings/SettingsPage"));
const ApiKeysSettingsPage = lazy(() =>
  import("pages/settings/ApiKeysSettingsPage")
);

export default [
  {
    path: "profile",
    element: <UserProfile />,
  },
  //
  // Settings
  {
    path: "settings",
    element: <SettingsPage />,
    children: [
      {
        path: "general",
        element: <GeneralSettingsPage />,
      },
      {
        path: "api-keys",
        element: <ApiKeysSettingsPage />,
      },
      {
        path: "preferences",
        element: <PreferencesSettingsPage />,
      },
    ],
  },
];
